'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = require('react');
var Millions = require('millions');

var Renderer = function (_React$Component) {
    (0, _inherits3.default)(Renderer, _React$Component);

    function Renderer(props) {
        (0, _classCallCheck3.default)(this, Renderer);

        var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(Renderer).call(this, props));

        _this.state = {};
        return _this;
    }

    (0, _createClass3.default)(Renderer, [{
        key: '_initRenderer',
        value: function _initRenderer(rendererClass) {
            this.renderer = new rendererClass(this.refs.mountpoint);
            this.forceUpdate();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.rendererClass) {
                this._initRenderer(this.props.rendererClass);
            } else {
                this._initRenderer(Millions.getBestSupportedRenderer());
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            if (newProps.rendererClass != this.props.rendererClass) {
                this._initRenderer(newProps.rendererClass);
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(newProps, newState) {
            return newProps.scene != this.props.scene || newProps.camera != this.props.camera;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            // We render after React's done any DOM manipulations, so that we get
            // the correct canvas size after resizes. If we rendered immediately
            // in render(), changes to styles wouldn't be propagated to the actual
            // DOM yet and Millions would still see the <canvas> in its previous state

            if (this.renderer) {
                this.renderer.render(this.props.scene, this.props.camera);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return React.createElement('canvas', { style: this.props.style, className: this.props.className,
                ref: 'mountpoint' });
        }
    }]);
    return Renderer;
}(React.Component);

exports.default = Renderer;
module.exports = exports['default'];



//////////////////
// WEBPACK FOOTER
// ./~/millions-react/build/compiled/Renderer.js
// module id = 912
// module chunks = 0